import { useEffect } from 'react';

/**
 * Runs callback when changes are being made to the DOM tree.
 * https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
 */
function useMutationObserver(elementRef, callback, {
  enabled = true,
  ...options
}) {
  useEffect(() => {
    if (!elementRef.current) return undefined;
    const observer = new MutationObserver(callback);
    observer.observe(elementRef.current, options);
    return () => observer.disconnect();
  }, [callback, enabled, ...Object.values(options).flat()]);
}

export { useMutationObserver as default };
